import api from "./axiosInstance";

export const uploadProductFiles = (formData: FormData) =>
  api.post("/pdf/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updateProductFiles = async (formData: FormData) =>
  api.put("/pdf/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteProductFiles = async (folderId: string) =>
  api.delete(`/pdf/delete/${folderId}`);

export const downloadProductFiles = async (folderId: string) =>
  api.get(`/downloads/daz/${folderId}`, { responseType: "blob" });
